import * as React from 'react';
import { useTranslation } from "react-i18next";
import {
    Avatar,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography
} from '@mui/material';

import RoomIcon from '@mui/icons-material/Room';

export default function LocationsList({locations, handleLocationSelection}) {

    const handleOnSelectLocation = function(event, location) {
        handleLocationSelection(location);
    };

    const { t } = useTranslation();

    const listItems = locations.map((location) => (
        <React.Fragment key={location.id}>
            <ListItem
                alignItems="flex-start"
                sx={{
                    cursor: "pointer"
                }}
                // secondaryAction={
                //     <>
                //         <IconButton
                //             component={Link}
                //             to={`/${location.id}/${location.city}`}
                //             label="Anzeigen"
                //             sx={{color: '#f5b4c8', bgcolor: '#4bb9e6'}}
                //         >
                //             <GpsFixedIcon />
                //         </IconButton>
                //         <IconButton
                //             component={Link}
                //             to={`/${location.id}/${location.city}/route`}
                //             label="Routenplaner"
                //             sx={{color: '#1eaf9b', bgcolor: '#f5b4c8'}}
                //         >
                //             <DirectionsIcon />
                //         </IconButton>
                //     </>
                // }
                onClick={(e) => handleOnSelectLocation(e, location)}
            >
                <ListItemAvatar>
                    <Avatar sx={{color: '#ffeb00', bgcolor: '#1eaf9b'}}>
                        <RoomIcon />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={location.name}
                    secondary={
                        <React.Fragment>
                            <Typography
                                sx={{ display: 'block', whiteSpace: "pre-line" }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                            >
                                {`${location.address.street}\n${location.address.postcode} ${t(location.address.city)}`}
                            </Typography>
                            {`${t(location.address.state)}, ${t(location.address.country.title)}`}
                        </React.Fragment>
                    }
                />
            </ListItem>
            <Divider variant="inset" component="li" />
        </React.Fragment>
    ));

    return (
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            {listItems}
        </List>
    );
}